import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { useDesignContext } from '@klarna/designtokens';
import Text from '@bubble-ui/primitive-text';
import Touchable from '@bubble-ui/primitive-touchable';
import View from '@bubble-ui/primitive-view';
import { defaultDesignTokens } from '../defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var NavBarActionBase = _ref => {
  var {
    action,
    colorToken,
    colorTokenArgs,
    id,
    onClick,
    onPress
  } = _ref;
  var designContext = useDesignContext(defaultDesignTokens);
  var designVersion = useDesignVersion();
  var ids = getIds(id);
  var [interactiveState, eventHandlers] = useInteractiveStateCombined();

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var {
    containerStyle,
    overlayStyle,
    actionWrapperStyle,
    actionTextStyle
  } = useStyleSheet(NavBarActionBase, getDefaultStyleSheet, {
    action,
    colorToken,
    colorTokenArgs,
    designContext,
    designVersion,
    focused: interactiveState.keyboardFocused,
    hovered: interactiveState.hovered,
    id,
    ids,
    interactiveState: interactiveState.interactiveState,
    onClick,
    onPress,
    pressed: interactiveState.pressed
  });
  return /*#__PURE__*/React.createElement(Touchable, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    onClick: onClick,
    onPress: onPress,
    style: containerStyle,
    type: "button"
  }, eventHandlers), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.overlay,
    style: overlayStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.actionWrapper,
    style: actionWrapperStyle
  }, /*#__PURE__*/React.createElement(Text, {
    id: ids === null || ids === void 0 ? void 0 : ids.action,
    numberOfLines: 0,
    tag: "paragraph",
    style: actionTextStyle
  }, action))));
};
NavBarActionBase.displayName = 'NavBarActionBase';
export default withProvisionalOverrideFromContext(NavBarActionBase);
//# sourceMappingURL=index.js.map